import { Axios } from "@/utils/axios";

export const putQuestion = async (id: number, content: string) => {
  const { data } = await Axios.put<{ id: number; content: string }>(`/questions/${id}/`, {
    content,
  });
  return data;
};
